<ng-template #rightOutlet>
  <rt-icon [name]="isMinimized ? 'expand-more' : 'expand-less'" class="icon-right"></rt-icon>
</ng-template>

<div *ngIf="items.length > 0">
  <rt-sidebar-item
    [name]="heading"
    [icon]="icon"
    [iconActive]="!isMinimized && !sidebarMinimized"
    [rightOutlet]="rightOutlet"
    [href]="sidebarMinimized ? items[0].url : undefined"
    [type]="ItemType.Heading"
    (click)="onHeaderClick()"
  ></rt-sidebar-item>
  <div class="group" [@collapse]="visibilityState" margin-bottom-small>
    <rt-sidebar-item
      *ngFor="let item of items; trackBy: trackByName"
      [name]="item.name"
      [href]="item.url"
      [rtcAnalyticsTrack]="item.analyticsEvent"
      [rtcAnalyticsTrackData]="item.analyticsEventData"
      [rightOutlet]="item.rightOutlet!"
      [rightOutletContext]="item.rightOutletContext!"
      [active]="router.url.includes(item.url) || router.url.includes(item.upgradeUrl!)"
      [type]="ItemType.Item"
    ></rt-sidebar-item>
  </div>
</div>
